
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from 'recharts';

const data = [
  { month: 'Current', normal: 119, moderate: 119, severe: 119 },
  { month: '1M', normal: 117, moderate: 112, severe: 105 },
  { month: '2M', normal: 114, moderate: 107, severe: 96 },
  { month: '3M', normal: 112, moderate: 103, severe: 92 },
  { month: '4M', normal: 110, moderate: 100, severe: 87 },
  { month: '5M', normal: 108, moderate: 97, severe: 84 },
  { month: '6M', normal: 107, moderate: 95, severe: 82 },
];

const LiquidityCoverageChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis domain={[70, 130]} />
        <Tooltip 
          formatter={(value) => [`${value}%`, undefined]}
          labelFormatter={(label) => `Period: ${label}`}
        />
        <Legend />
        <ReferenceLine y={100} stroke="#ff6b6b" strokeDasharray="3 3" label="Regulatory Minimum" />
        <Line type="monotone" dataKey="normal" name="Normal Conditions" stroke="#22c55e" strokeWidth={2} dot={{ r: 4 }} />
        <Line type="monotone" dataKey="moderate" name="Moderate Stress" stroke="#f59e0b" strokeWidth={2} dot={{ r: 4 }} />
        <Line type="monotone" dataKey="severe" name="Severe Stress" stroke="#ef4444" strokeWidth={2} dot={{ r: 4 }} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default LiquidityCoverageChart;
